import { BrandsEnum } from "../../enums";
export const useBrandNavigationHighligher = () => {
    function handleLinkHighlight(item, brand) {
        //some brands may have specific cases for highlighting navigation items.
        //volvia have sub brands under same domain so it complicates things
        //we need to highlight foretag node for links under /foretag/xxx
        const currentUrl = window.location.href;
        const itemUrl = item.href;
        if (brand == BrandsEnum.Volvia ||
            brand == BrandsEnum.VolviaForetag ||
            brand == BrandsEnum.VolviaLastbilar) {
            //highlight if link has same root as navigation main link
            if (!itemUrl.includes("/lastbilar") && !itemUrl.includes("/foretag") && !itemUrl.includes("/anlaggningsmaskiner")) {
                // Case: Volvia privat node
                return (!currentUrl.includes("/lastbilar") && !currentUrl.includes("/foretag") && !currentUrl.includes("/anlaggningsmaskiner"));
            }
            else {
                // Cases: Volvia lastbilar/foretag/anlaggningsmaskiner node
                return currentUrl.includes(item.href);
            }
        }
        if (brand === BrandsEnum.Renault ||
            brand === BrandsEnum.RenaultForetag ||
            brand == BrandsEnum.Polestar ||
            brand == BrandsEnum.PolestarMO ||
            brand == BrandsEnum.PolestarForetag ||
            brand == BrandsEnum.PolestarForetagMO) {
            //highlight if link has same root as navigation main link
            if (!itemUrl.includes("/foretag")) {
                // Case: Renault privat node
                return !currentUrl.includes("/foretag");
            }
            else {
                // Case: Renault/polestar foretag node
                return currentUrl.includes(item.href);
            }
        }
        if (brand == BrandsEnum.PolestarFI ||
            brand == BrandsEnum.PolestarFIMO ||
            brand == BrandsEnum.PolestarForetagFI ||
            brand == BrandsEnum.PolestarForetagFIMO) {
            //highlight if link has same root as navigation main link
            if (!itemUrl.includes("/yritysasiakkaat")) {
                // Case: PolestarFI privat node
                return !currentUrl.includes("/yritysasiakkaat");
            }
            else {
                // Case: PolestarFI foretag node
                return currentUrl.includes(item.href);
            }
        }
        //other brands for now don't have any specific private & commercial setup
        return true;
    }
    return {
        handleLinkHighlight,
    };
};
export default useBrandNavigationHighligher;
